import React from "react";
import { styled } from "@mui/material";
import loading from "../../assets/social-media.gif";

const StyledLoading = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "inherit",
});

const Loading = () => {
  return (
    <StyledLoading>
      <img width="80" alt="loading" src={loading} />
    </StyledLoading>
  )
}

export default Loading;